import { render, staticRenderFns } from "./complianceTemplate.vue?vue&type=template&id=19b24120&lang=en&"
import script from "./complianceTemplate.vue?vue&type=script&lang=js&"
export * from "./complianceTemplate.vue?vue&type=script&lang=js&"
import style0 from "./complianceTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports